(() => {
  const toEmbedUrl = (url) => {
    try {
      const parsed = new URL(url, window.location.origin);
      if (parsed.hostname.includes('youtu.be')) return `https://www.youtube.com/embed/${parsed.pathname.slice(1)}?autoplay=1`;
      if (parsed.hostname.includes('youtube.com')) {
        const id = parsed.searchParams.get('v') || parsed.pathname.split('/').filter(Boolean).pop();
        return `https://www.youtube.com/embed/${id}?autoplay=1`;
      }
      if (parsed.hostname.includes('vimeo.com')) {
        const id = parsed.pathname.split('/').filter(Boolean).pop();
        return `https://player.vimeo.com/video/${id}?autoplay=1`;
      }
      return url;
    } catch (_) {
      return url;
    }
  };

  const initialise = (root) => {
    if (!root || root.dataset.trailerInitialised === 'true') return;
    root.dataset.trailerInitialised = 'true';

    const openButton = root.querySelector('[data-trailer-open]');
    const modal = root.querySelector('[data-trailer-modal]');
    const frame = root.querySelector('[data-trailer-frame]');
    if (!openButton || !modal || !frame) return;

    const closeButtons = modal.querySelectorAll('[data-trailer-close]');
    const close = () => {
      modal.hidden = true;
      frame.removeAttribute('src');
      document.body.style.overflow = '';
      openButton.focus();
    };

    openButton.addEventListener('click', () => {
      frame.src = toEmbedUrl(openButton.dataset.trailerUrl);
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      modal.querySelector('.masterclass-trailer-modal__close').focus();
    });

    closeButtons.forEach((button) => button.addEventListener('click', close));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modal.hidden) close();
    });
  };

  document.querySelectorAll('.masterclass-product').forEach(initialise);
  document.addEventListener('shopify:section:load', (event) => initialise(event.target.querySelector('.masterclass-product')));
})();
